export default "__VITE_ASSET__LS5bhHQP__"